<script setup lang="ts"></script>

<template>
  <div>
    <v-container>
      <v-row class="my-5">
        <v-col v-for="index in 3" :key="index" cols="12" sm="6" md="4">
          <v-skeleton-loader type="image, article" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped></style>
